<template>
  <v-dialog
    :model-value="dialogValue"
    @update:modelValue="updateDialogValue"
    width="550"
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>{{ $t('settings.verify-domain-dialog.title') }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              theme="dark"
              @click="$emit('close')"
            >
              <v-icon size="large"> mdi-close </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>

      <v-card-text class="mt-4 text-body-1">
        <div class="pb-4">{{ $t('settings.verify-domain-dialog.description-1') }}</div>
        <div class="pb-4">
          {{ $t('settings.verify-domain-dialog.description-2') }}
        </div>
        <a
          href="https://postmarkapp.com/support/article/1090-resources-for-adding-dkim-and-return-path-records-to-dns-for-common-hosts-and-dns-providers"
          target="_blank"
          rel="noopener"
          >{{ $t('settings.verify-domain-dialog.link-text') }}</a
        >
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="success"
          variant="text"
          @click="$emit('close')"
        >
          {{ $t('settings.verify-domain-dialog.close-button') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: { type: Boolean, default: false },
  },
  computed: {
    dialogValue: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },
  methods: {
    updateDialogValue(value) {
      this.dialogValue = value
    },
  },
  emits: ['update:dialog', 'close'],
}
</script>
